import { render, staticRenderFns } from "./Partaner.vue?vue&type=template&id=27395422&scoped=true"
import script from "./Partaner.vue?vue&type=script&lang=js"
export * from "./Partaner.vue?vue&type=script&lang=js"
import style0 from "./Partaner.vue?vue&type=style&index=0&id=27395422&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27395422",
  null
  
)

export default component.exports